export enum KeyCode {
  TAB = 'Tab',
  ENTER = 'Enter',
  ESC = 'Escape',
  SPACE = ' ',
  END = 'End',
  HOME = 'Home',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_UP = 'ArrowUp',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_DOWN = 'ArrowDown',
  I  = 'i'
}
